import { extractNetworkErrorMessage } from '@/utils'

export const skipValidationError = error => {
  if (error.validationErrors) { return null }
  return []
}

const extractErrorMessage = error => {
  console.log(error)
  return error && error.message
}

export const defaultPipeline = [
  // skipValidationError,
  extractNetworkErrorMessage,
  extractErrorMessage
]

export function extractErrorWithPipeline (error, pipeline) {
  const result = pipeline.reduce((acc, handler) => {
    if (acc == null) { return }

    const result = handler(error)

    if (result == null) { return acc }

    if (typeof result === 'string') {
      acc.messages.push(result)
      return acc
    } else if (result.length > 0) {
      acc.messages.push(result[0])
      return acc
    } else {
      return acc
    }
  }, { messages: [] })

  if (result && result.messages.length > 0) {
    return result.messages[0]
  }
}



// WEBPACK FOOTER //
// ./src/services/toast/error.js